import { SlideshowTitleStyle } from '@website-builder/widgets/slidershow/model/slideshow-title-style';

export class SlideshowSubtitleStyle extends SlideshowTitleStyle {
  alignment = '';

  static normalize(styles: Partial<SlideshowSubtitleStyle>): SlideshowSubtitleStyle {
    const slideshowTitleStyle: SlideshowTitleStyle = SlideshowTitleStyle.normalize(styles);
    const pureStyles = new SlideshowSubtitleStyle();

    Object.assign(pureStyles, slideshowTitleStyle);

    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;

    return pureStyles;
  }
}
